import axios from 'axios';

export default class MavenContext {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async getSystemContext(brandId, type) {
    const result = await axios.get(`${this.baseURL}/account/${brandId}/${type}/context`);
    return result.data;
  }

  async getSdeList(brandId) {
    const result = await axios.get(`${this.baseURL}/account/${brandId}/sde/variables/list`);
    return result.data;
  }
}
